import React, { useRef } from 'react';
var VeltInlineCommentsSectionFilterDropdownContentList = function (props) {
    var defaultCondition = props.defaultCondition, children = props.children;
    var ref = useRef(null);
    return (React.createElement("velt-inline-comments-section-filter-dropdown-content-list", { ref: ref, "default-condition": [true, false].includes(defaultCondition) ? (defaultCondition ? 'true' : 'false') : undefined }, children));
};
export default VeltInlineCommentsSectionFilterDropdownContentList;
